import { AppBar, Layout as RALayout } from 'react-admin'
import Typography from '@material-ui/core/Typography'
import { PropertiesList } from './PropertiesList'
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Footer from '../elements/Footer'

const useStyles = makeStyles({
  title: {
    flex: 1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  spacer: {
    flex: 1
  }
})

const Layout = (props) => {
  const classes = useStyles()
  return (
    <>
      <RALayout
        style={{
          marginBottom: 60,
          minHeight: 'calc(100vh - 60px)'
        }}
        appBar={(appBarProps) => (
          <AppBar {...appBarProps}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography
                variant='h6'
                color='inherit'
                className={classes.title}
                style={{ marginRight: 20 }}
                id='react-admin-title'
              />
              <PropertiesList />
            </div>
            <span className={classes.spacer} />
          </AppBar>
        )} {...props}
      />
      <Footer />
    </>
  )
}

export default Layout
